import styled from "@emotion/styled";
import React, { CSSProperties } from "react";

const CustomDiv = styled.div`
  & > * {
    display: inline-block !important;
  }
`;

export const XInline = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: CSSProperties;
}) => {
  return <CustomDiv style={style}>{children}</CustomDiv>;
};
